import React from 'react';

export default () =>{

    return	(
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 15.5C0 15.776 0.275685 16 0.615385 16H15.3846C15.7243 16 16 15.776 16 15.5C16 11.9126 12.4153 9 8 9C3.5847 9 0 11.9126 0 15.5ZM8 0C5.28309 0 3.07692 1.79251 3.07692 4C3.07692 6.20749 5.28309 8 8 8C10.7169 8 12.9231 6.20749 12.9231 4C12.9231 1.79251 10.7169 0 8 0Z" fill="black"/>
        </svg>
    )
}